<template>
  <b-modal size="xl" :id="modalName" hide-footer hide-header>
    <div>
      <button class="closeModal" @click="$bvModal.hide(modalName)">
        <b-icon-x scale="1.3" />
      </button>

      <ProductsMobile
        @getAllProducts="createdNewproduct = $event"
        :idProductFromSearch="idProductFromSearch"
      />
    </div>
  </b-modal>
</template>

<script>
import ProductsMobile from "../Products/ProductsMobile.vue";
export default {
  props: {
    idProductFromSearch: {
      type: String,
    },
    modalName: {
      type: String,
      default: "modalCreateProductMobile",
    },
  },
  data() {
    return {
      createdNewproduct: null,
    };
  },
  components: {
    ProductsMobile,
  },
  methods: {},
  watch: {
    createdNewproduct() {
      this.$emit("getAllNewProduct", this.createdNewproduct);
      this.createdNewproduct = null;
    },
  },
  computed: {},
};
</script>

<style scoped>
.btnBack {
  border-radius: 5px;
  background-color: #006256;
  border: none;
  margin-top: 30px;
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 13px;
  width: 150px;
  font-size: 18px;
  margin-top: 0;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}
</style>